import { PillBadge } from '@platform/components';
import type { StatCardProps } from './types';

export const StatCard = ({ title, total, rows }: StatCardProps) => (
  <div className='flex flex-1 flex-col gap-4 rounded-xl border border-gray-100 bg-white p-6'>
    <h2 className='text-base font-semibold text-gray-700'>{title}</h2>
    <div className='text-5xl font-semibold tracking-tight text-gray-700'>{total}</div>
    <div className='flex flex-col gap-2'>
      {rows.map((row) => (
        <div key={row.label} className='flex items-center justify-between'>
          <span className='flex items-center'>
            {row.badge ?
              <PillBadge variant='plain' color='warning' size='sm'>
                {row.label}
              </PillBadge>
            : <span className={`text-md font-medium ${row.labelColor}`}>{row.label}</span>}
            {row.sublabel && <span className='ml-1 text-sm text-gray-400'>| {row.sublabel}</span>}
          </span>
          {row.value !== undefined && (
            <span className='text-md font-semibold text-gray-700'>{row.value}</span>
          )}
        </div>
      ))}
    </div>
  </div>
);
